/**
 * Progressive image: fade in main image on load, then fade out and remove blur placeholder.
 * Queries all .image-snippet__main and attaches load listeners.
 */
(function () {
  const FADE_OUT_MS = 400;

  function runReveal(mainImg) {
    if (mainImg.dataset.progressiveRevealed) return;
    mainImg.dataset.progressiveRevealed = "1";

    var wrapper = mainImg.closest(".image-snippet__wrapper");
    if (!wrapper) return;

    var placeholder = wrapper.querySelector(".image-snippet__placeholder");
    if (!placeholder) return;

    // Already fading out from an earlier call: leave that timer to finish
    // rather than starting a second one for the same node.
    if (placeholder.style.opacity === "0") return;

    placeholder.style.opacity = "0";
    var removeId = window.setTimeout(function () {
      mainImg.dataset.progressiveImageTimeout = "";
      if (placeholder.parentNode) {
        placeholder.parentNode.removeChild(placeholder);
      }
    }, FADE_OUT_MS);
    mainImg.dataset.progressiveImageTimeout = String(removeId);
  }

  function clearAllTimeouts() {
    document.querySelectorAll(".image-snippet__main[data-progressive-image-timeout]").forEach(function (img) {
      var id = img.dataset.progressiveImageTimeout;
      if (id) window.clearTimeout(Number(id));
      img.dataset.progressiveImageTimeout = "";
    });
  }

  function onMainImageLoad(e) {
    var mainImg = e.target;
    if (mainImg.classList.contains("image-snippet__main")) {
      runReveal(mainImg);
    }
  }

  function init() {
    var mainImages = document.querySelectorAll(".image-snippet__main");
    mainImages.forEach(function (img) {
      if (img.complete) {
        runReveal(img);
      }
    });
  }

  /**
   * Re-check a subtree for images that are decoded but still wearing their blur
   * placeholder, and reveal them.
   *
   * init() runs once at startup, and the "load" listener fires once per image.
   * Neither covers a gallery that REORDERS its slides afterwards: the metal
   * filter moves an offscreen, never-loaded lazy slide to position one, so its
   * placeholder is still on top and no further load event is coming for it.
   * The same gap catches images served from cache, which can be complete before
   * any listener is attached.
   *
   * Images that genuinely have not downloaded yet are left alone - they keep
   * the placeholder and reveal normally through the load listener.
   *
   * @param {Element} [root] - subtree to scan; defaults to the whole document
   */
  function refresh(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".image-snippet__main").forEach(function (img) {
      // naturalWidth weeds out images that errored: those report complete too,
      // and revealing them would swap a blurred preview for a broken icon.
      if (img.complete && img.naturalWidth > 0) {
        // Clear the guard so a slide blurred at page load can still be
        // revealed now that it has decoded.
        img.dataset.progressiveRevealed = "";
        runReveal(img);
      }
    });
  }

  // Let other components (the product gallery, which reorders slides) ask for
  // a re-check after they rearrange the DOM.
  window.progressiveImageRefresh = refresh;

  document.addEventListener("load", onMainImageLoad, true);

  window.addEventListener("beforeunload", clearAllTimeouts);
  window.addEventListener("pagehide", clearAllTimeouts);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
